/**
 * Format seconds to duration in HH:MM:SS format.
 *
 * @example
 * formatSecondsToDuration(3600) -> "01:00:00"
 * formatSecondsToDuration(3600 + 60) -> "01:01:00"
 * formatSecondsToDuration(3600 + 60 + 1) -> "01:01:01"
 */
export const formatSecondsToDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return [
    String(hours).padStart(2, "0"),
    String(minutes).padStart(2, "0"),
    String(remainingSeconds).padStart(2, "0"),
  ].join(":");
};
